import { Fragment, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { XMarkIcon, ArrowPathIcon } from '@heroicons/react/24/outline'
import Button from 'components/Button/Button'
import { connect } from 'react-redux'
import { regenerateQR } from 'store/actions/auth'
import { toast } from 'react-toastify'

const QRCodeModal = ({ open, setOpen, user, regenerateQR }) => {
    const [loading, setLoading] = useState(false);

    const handleRegenerate = async () => {
        setLoading(true);
        try {
            await regenerateQR()
            toast.success("QR Code regenerated successfully")
        } catch (error) {
            toast.error("Failed to regenerate QR code")
        } finally {
            setLoading(false);
        }
    }

    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog as="div" className="relative z-[2000]" onClose={setOpen}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
                                <div className="absolute top-0 right-0 hidden pt-4 pr-4 sm:block">
                                    <button
                                        type="button"
                                        className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                        onClick={() => setOpen(false)}
                                    >
                                        <span className="sr-only">Close</span>
                                        <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                                    </button>
                                </div>
                                <div>
                                    <div className="mt-3 text-center sm:mt-5">
                                        <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
                                            My QR Code
                                        </Dialog.Title>
                                        <div className="mt-4 flex justify-center">
                                            {user.qrCodeUrl ? (
                                                <img src={user.qrCodeUrl} alt="My QR Code" className="w-48 h-48 object-contain border rounded-lg" />
                                            ) : (
                                                <div className="w-48 h-48 flex items-center justify-center border rounded-lg bg-gray-50 text-gray-400 text-sm">
                                                    No QR Code
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-5 sm:mt-6">
                                    <Button
                                        type="button"
                                        loading={loading}
                                        disabled={loading}
                                        className="w-full justify-center !py-2 flex items-center gap-2"
                                        onClick={handleRegenerate}
                                    >
                                        <ArrowPathIcon className="h-5 w-5" />
                                        {user.qrCodeUrl ? 'Regenerate QR Code' : 'Generate QR Code'}
                                    </Button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
}

const mapStateToProps = ({ auth }) => ({
    user: auth.user
})

export default connect(mapStateToProps, { regenerateQR })(QRCodeModal)
